import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=0564dbfe"
import script from "./MessageItem.vue?vue&type=script&lang=js"
export * from "./MessageItem.vue?vue&type=script&lang=js"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=0564dbfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports